import { DataService } from './../../services/data.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';



@Component({
  selector: 'app-show-movie',
  templateUrl: './show-movie.component.html',
  styleUrls: ['./show-movie.component.scss']
})
export class ShowMovieComponent implements OnInit {

  movieData;
  allFilterList = {};
  movieSdg;

  descriptionContent = false;

  // videoUrl='https://www.youtube.com/embed/Knd5NIro5Y0';

  constructor(public dialogRef: MatDialogRef<ShowMovieComponent>,
    public router: Router,
    // private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data, private serviceData: DataService) { }

  ngOnInit(): void {
    // console.log(this.data, 'data');

    // this.movie = this.data.movie;
    this.movieData = this.data.movie;
    // console.log(this.movieData, 'jj');
    if (this.data.quizVideo == false) {
      this.allFilterList = this.serviceData.filters;

      if (this.movieData['sdg_ids']?.length > 0) {
        let movieData = this.movieData;
        this.movieSdg = this.allFilterList['sdg'].filter(function (sdg) {
          // console.log(movieData,'dddd');
          // console.log(sdg);
          return (sdg.id == movieData.sdg_ids[0]);
        })

      }
    }



    // console.log(this.movieSdg,'data');

  }
  showAllVideosInSdg() {
    this.serviceData.sdgSelected.next(this.movieSdg[0]);
    this.close()
  }

  close() {
    this.dialogRef.close();
  }

}
